/**
 * يفتح لوحة الأوامر (⌘K) من أي زر — اللوحة تستمع للاختصار عبر react-hotkeys-hook،
 * فنرسل ضغطة اصطناعية بدل استيرادها (تبقى بحزمتها الكسولة ولا حلقة استيراد).
 */
export function openCommandPalette() {
  const isMac = navigator.platform.toUpperCase().includes('MAC')
  document.dispatchEvent(
    new KeyboardEvent('keydown', {
      key: 'k',
      code: 'KeyK',
      metaKey: isMac,
      ctrlKey: !isMac,
      bubbles: true,
    }),
  )
}

/** نص الاختصار بحسب الجهاز: ⌘K على ماك و Ctrl K على غيره */
export const paletteShortcut = () =>
  navigator.platform.toUpperCase().includes('MAC') ? '⌘K' : 'Ctrl K'
